import React from 'react';
import InputV1 from '../../../../../components/ComponentsV1/InputV1';
import { ENTITY_TYPE } from '../constants';
import { Search } from 'lucide-react';

const SearchBar = ({
  openForm,
  categoriesLoading,
  options,
  selectedEntityType,
  setProductInput,
  setEntityId,
  entityId,
  productInput,
}) => {
  return (
    <div className='tw-flex tw-justify-end'>
      <InputV1
        enableKeyPress={!openForm}
        loading={categoriesLoading}
        options={options || []}
        className='tw-w-full tw-h-[4.5rem]'
        placeholder={
          selectedEntityType === ENTITY_TYPE.CATEGORY
            ? 'Search by Category ID or Name'
            : 'Enter Product ID and press Enter'
        }
        multiple={false}
        isSearchable={selectedEntityType === ENTITY_TYPE.CATEGORY}
        inputProps={{
          className: 'tw-w-[30rem] tw-border-none',
          type: selectedEntityType === ENTITY_TYPE.CATEGORY ? 'text' : 'number',
        }}
        searchIcon={
          <Search size={18} strokeWidth={2.4} className='tw-text-base-green' />
        }
        closeOnSelect
        onChange={(val) => {
          if (selectedEntityType === ENTITY_TYPE.PRODUCT) {
            setProductInput(val);
          }
        }}
        onSelect={(selectedValue) => {
          if (selectedEntityType === ENTITY_TYPE.CATEGORY) {
            setEntityId(selectedValue?.value);
          } else {
            // For product mode, Enter triggers onSelect with the current input value
            setEntityId(selectedValue);
          }
        }}
        value={
          selectedEntityType === ENTITY_TYPE.PRODUCT ? productInput : entityId
        }
      />
    </div>
  );
};

export default SearchBar;
